<div class="greyed-out" disabled>
  <app-sign-in></app-sign-in>
</div>
